module.exports = __webpack_public_path__ + "img/49649.f33b4c00.svg";